import React, { PropTypes, PureComponent } from 'react';

import CourseMaps from './component';

/**
 * Course Maps container component.
 * Wraprs presentational component in state to handle lightbox state control.
 */
class CourseMapImagesContainer extends PureComponent {
  state = {
    lightboxCurrentImage: 0,
    lightboxIsOpen: false,
  };

  handleClick = (event, index) => {
    event.preventDefault();
    this.setState({ lightboxCurrentImage: index, lightboxIsOpen: true });
  };

  handleLightboxPrev = () => {
    this.setState(state => ({
      lightboxCurrentImage:
        state.lightboxCurrentImage === 0
          ? this.props.images.length - 1
          : state.lightboxCurrentImage - 1,
    }));
  };

  handleLightboxNext = () => {
    this.setState(state => ({
      lightboxCurrentImage:
        state.lightboxCurrentImage === this.props.images.length - 1
          ? 0
          : state.lightboxCurrentImage + 1,
    }));
  };

  handleLightboxClose = () => {
    this.setState({ lightboxIsOpen: false });
  };

  render() {
    return (
      <CourseMaps
        onClick={this.handleClick}
        lightboxOnClickPrev={this.handleLightboxPrev}
        lightboxOnClickNext={this.handleLightboxNext}
        lightboxOnClose={this.handleLightboxClose}
        {...this.props}
        {...this.state}
      />
    );
  }
}

CourseMapImagesContainer.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape(),
  ).isRequired,
};

export default CourseMapImagesContainer;



// WEBPACK FOOTER //
// ./app/src/components/EventDetail/CourseMapImages/container.jsx